import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ObAccountModel } from 'src/app/models/ob-account.model';
import { ObInstitutionModel } from 'src/app/models/ob-institution.model';
import { OpenBankingService } from 'src/app/services/open-banking.service';

export type OpenBankingMode = 'institutions' | 'accounts';

@Component({
  selector: 'app-apg-open-banking-institutions',
  templateUrl: './apg-open-banking-institutions.component.html',
  styleUrls: ['./apg-open-banking-institutions.component.scss']
})
export class ApgOpenBankingInstitutionsComponent implements OnInit, OnDestroy {
  institutions$ = new Observable<ObInstitutionModel[]>();
  @Input() accounts: ObAccountModel;
  @Input() mode: OpenBankingMode = 'institutions';
  @Output() selectInst: EventEmitter<ObInstitutionModel> = new EventEmitter<ObInstitutionModel>();
  @Output() selectAcc: EventEmitter<ObAccountModel> = new EventEmitter<ObAccountModel>();
  selectInstitutionText: string;
  selectAccountText: string;
  loading = true;

  constructor(
    private openBanking: OpenBankingService
  ) {

  }

  ngOnDestroy(): void {
    if (this.selectInst) {
      this.selectInst.unsubscribe();
    }
  }

  async ngOnInit() {
    this.institutions$ = this.openBanking.getInstitutions$().pipe(tap(_ => this.loading = false));
  }

  async selectInstitution(institution: ObInstitutionModel) {
    this.selectInst.emit(institution);
  }

  async selectAccount(account: ObAccountModel) {
    this.selectAcc.emit(account);
  }

  selectImage(institution: ObInstitutionModel) {
    let imageUrl = institution.media.find(x => x.type === 'logo').source;
    return imageUrl;
  }
}
